// User Preferences Manager
const storageKey = 'userPreferences';
const defaultPrefs = {
	userTimeZone: 'America/New_York',
	userMeasUnits: 'imperial',
};

const UserPrefsManager = {
	// Get all user preferences
	getAll() {
		const prefs = localStorage.getItem(storageKey);
		return prefs ? JSON.parse(prefs) : { ...defaultPrefs };
	},

	// Get a single user preference by key
	get(key) {
		const prefs = this.getAll();
		return key in prefs ? prefs[key] : null;
	},

	// Set a single user preference
	set(key, value) {
		const prefs = this.getAll();
		prefs[key] = value;
		localStorage.setItem(storageKey, JSON.stringify(prefs));
	},

	// Remove a single user preference
	remove(key) {
		const prefs = this.getAll();
		if (key in prefs) {
			delete prefs[key];
			localStorage.setItem(storageKey, JSON.stringify(prefs));
		}
	},

	// Remove all user preferences
	removeAll() {
		localStorage.removeItem(storageKey);
	},

	// Reset all user preferences to default
	reset() {
		localStorage.setItem(storageKey, JSON.stringify({ ...defaultPrefs }));
	}
};

export default UserPrefsManager;